var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStripe = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#635BFF",
    fillRule: "evenodd",
    d: "M39 20.267c0-2.734-1.309-4.892-3.81-4.892-2.513 0-4.033 2.158-4.033 4.87 0 3.216 1.795 4.84 4.37 4.84 1.256 0 2.206-.29 2.924-.695v-2.136c-.718.363-1.541.587-2.586.587-1.024 0-1.932-.363-2.048-1.623h5.162c0-.14.021-.695.021-.951m-5.214-1.015c0-1.207.728-1.709 1.393-1.709.644 0 1.33.502 1.33 1.71h-2.723Zm-6.703-3.877c-1.035 0-1.7.492-2.07.833l-.136-.662h-2.323V28l2.64-.566.01-3.023c.38.278.94.673 1.868.673 1.89 0 3.61-1.538 3.61-4.924-.01-3.097-1.752-4.785-3.6-4.785Zm-.634 7.36c-.622 0-.992-.225-1.245-.503l-.01-3.962c.274-.31.654-.524 1.255-.524.961 0 1.626 1.09 1.626 2.489 0 1.431-.654 2.5-1.626 2.5m-7.526-7.99 2.65-.577V12l-2.65.566z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#635BFF",
    d: "M21.573 15.557h-2.65v9.345h2.65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#635BFF",
    fillRule: "evenodd",
    d: "m16.084 16.347-.169-.79h-2.28v9.345h2.639V18.57c.623-.823 1.678-.673 2.005-.556v-2.456c-.337-.128-1.572-.363-2.195.79Zm-5.278-3.108-2.575.555-.011 8.556c0 1.58 1.172 2.745 2.734 2.745.865 0 1.499-.16 1.847-.353v-2.168c-.338.139-2.005.63-2.005-.95v-3.792H12.8v-2.275h-2.005zM3.67 18.27c0-.417.338-.577.898-.577.802 0 1.815.246 2.618.683v-2.51a6.9 6.9 0 0 0-2.618-.49C2.425 15.375 1 16.506 1 18.397c0 2.948 4.011 2.478 4.011 3.749 0 .491-.422.651-1.013.651-.876 0-1.995-.363-2.882-.854v2.542a7.2 7.2 0 0 0 2.882.609c2.195 0 3.705-1.1 3.705-3.012-.01-3.183-4.032-2.617-4.032-3.813Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStripe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stripe.dd7f9229.svg";